import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../utils/util';
import HomeDefault from '../../../../components/HomeDefaultComponent';

const AreaConversion = (props) => {

    const menuArea = () => {
        return [
            { route: { pathname: '/warehousemanagement/location/areaconversion/insert' }, icon: 'mdi mdi-plus-box-outline', text: translate("new-area-conversion", 'physical-confirmation') },
            { route: { pathname: '/warehousemanagement/location/areaconversion/list' }, icon: 'mdi mdi-clipboard-list-outline', text: translate("list-area-conversion", 'physical-confirmation') }
        ];
    };

    return (
        <HomeDefault menu={menuArea()} title={{ icon: "mdi mdi-clipboard-check-outline", label: translate("area-conversion", 'physical-confirmation') }} />
    );
};

export default withRouter(withTranslation()(AreaConversion));
